module.exports = __webpack_public_path__ + "img/cr_get.8d84e01.png";